var LOADING_MESSAGE = {
  loadingData: 'Daten werden geladen...',
  loadingStream: 'Meldungen werden geladen...',
  loadingHighlights: 'Highlights werden geladen...',
  loadingLineup: 'Aufstellung wird geladen...',
  loadingPlayers: 'Spieler werden geladen...',
  loadingMatches: 'Spiele werden geladen...',
  loadingPrevMatches: 'Frühere Spiele werden geladen...',
  loadingStandings: 'Tabelle wird geladen...'
};
export { LOADING_MESSAGE };
//# sourceMappingURL=LoadingMessages.js.map